// components/B2BProductsPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../CartContext';
import { getB2BProductsByCategory, getB2BCategories, mediaUrl } from '../api';

export default function B2BProductsPage() {
  const { categoryName, categoryId } = useParams();
  const navigate = useNavigate();
  const { addToCart, userType, switchUserType } = useCart();

  const [products, setProducts]     = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [quantities, setQuantities] = useState({});
  const [added, setAdded]           = useState({});

  const decodedName = decodeURIComponent(categoryName);

  useEffect(() => {
    if (userType !== 'b2b') switchUserType('b2b', { silent: true });
  }, [userType, switchUserType]);

  useEffect(() => {
    getB2BCategories()
      .then(res => { if (res.success) setCategories(res.categories || []); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!categoryId) return;
    setLoading(true);
    getB2BProductsByCategory(categoryId)
      .then(res => { if (res.success) setProducts(res.products || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [categoryId]);

  const handleQty = (id, val, minOrder = 1) => {
    let q = parseInt(val) || minOrder;
    if (q < minOrder) q = minOrder;
    setQuantities(prev => ({ ...prev, [id]: q }));
  };

  const handleAdd = (product) => {
    const qty = quantities[product.id] || product.min_order || 1;
    addToCart({
      id:       product.id,
      name:     product.name,
      price:    parseFloat(product.price),
      image:    product.image_url,
      category: product.category,
      unit:     product.unit || 'kg',
      min_order: product.min_order || 1, // Pass min_order
      isB2B:    true,
    }, qty, 'b2b');
    setAdded(prev => ({ ...prev, [product.id]: true }));
    setTimeout(() => setAdded(prev => ({ ...prev, [product.id]: false })), 1400);
  };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>

      {/* Breadcrumb */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '10px 0' }}>
        <div className="container" style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', color: '#6b7280' }}>
          <button onClick={() => navigate('/b2b')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#16a34a', fontWeight: 600, fontSize: '0.8rem', padding: 0 }}>B2B Home</button>
          <span>›</span>
          <span style={{ color: '#111827', fontWeight: 500 }}>{decodedName}</span>
        </div>
      </div>

      {/* Category pills */}
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '10px 0' }}>
        <div className="container">
          <style>{`.km-b2b-pills::-webkit-scrollbar{display:none}`}</style>
          <div className="km-b2b-pills" style={{ display: 'flex', gap: '8px', overflowX: 'auto', msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
            {categories.map(cat => {
              const active = String(cat.id) === String(categoryId);
              return (
                <button key={cat.id}
                  onClick={() => navigate(`/b2b/products/${encodeURIComponent(cat.name)}/${cat.id}`)}
                  style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px', padding: '5px 12px', borderRadius: '20px', border: `1.5px solid ${active ? '#16a34a' : '#e5e7eb'}`, background: active ? '#f0fdf4' : '#fff', color: active ? '#16a34a' : '#374151', fontWeight: active ? 700 : 500, fontSize: '0.78rem', cursor: 'pointer', whiteSpace: 'nowrap' }}
                  onMouseEnter={e => { if (!active) { e.currentTarget.style.borderColor = '#16a34a'; e.currentTarget.style.color = '#16a34a'; } }}
                  onMouseLeave={e => { if (!active) { e.currentTarget.style.borderColor = '#e5e7eb'; e.currentTarget.style.color = '#374151'; } }}
                >
                  {cat.icon && <span>{cat.icon}</span>}
                  {cat.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Heading */}
      <div className="container" style={{ padding: '20px 1rem 0' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px' }}>
          <h1 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#111827', margin: 0 }}>{decodedName}</h1>
          {!loading && <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>{products.length} products</span>}
        </div>
      </div>

      {/* Products */}
      <div className="container" style={{ padding: '16px 1rem 3rem' }}>
        {loading && (
          <div style={{ textAlign: 'center', padding: '4rem' }}>
            <div style={{ width: 36, height: 36, border: '3px solid #16a34a', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite', margin: '0 auto 12px' }} />
            <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
          </div>
        )}

        {!loading && products.length === 0 && (
          <div style={{ textAlign: 'center', padding: '4rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '12px' }}>📦</div>
            <p style={{ fontWeight: 600, color: '#374151' }}>No products found</p>
            <button onClick={() => navigate('/b2b')} style={{ marginTop: '12px', padding: '8px 20px', background: '#16a34a', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>Back to B2B Home</button>
          </div>
        )}

        {!loading && products.length > 0 && (
          <>
            <style>{`
              .km-b2b-prod-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:14px;margin-top:4px}
              @media(max-width:1024px){.km-b2b-prod-grid{grid-template-columns:repeat(4,1fr)}}
              @media(max-width:768px){.km-b2b-prod-grid{grid-template-columns:repeat(3,1fr)}}
              @media(max-width:480px){.km-b2b-prod-grid{grid-template-columns:repeat(2,1fr)}}
              
              /* Fix + Add button text alignment and font size on mobile */
              @media (max-width: 768px) {
                .b2b-prod-add-btn-fix {
                  text-align: left !important;
                  justify-content: flex-start !important;
                  font-size: 0.65rem !important;
                }
              }
              @media (max-width: 480px) {
                .b2b-prod-add-btn-fix {
                  text-align: left !important;
                  justify-content: flex-start !important;
                  font-size: 0.6rem !important;
                }
              }
            `}</style>
            <div className="km-b2b-prod-grid">
              {products.map(product => {
                const qty     = quantities[product.id] || product.min_order || 1;
                const price   = parseFloat(product.price);
                const retail  = product.retail_price ? parseFloat(product.retail_price) : null;
                const savings = retail ? Math.round(((retail - price) / retail) * 100) : null;
                const isAdded = added[product.id];

                return (
                  <div key={product.id} style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb', overflow: 'hidden', position: 'relative', transition: 'box-shadow 0.2s, transform 0.2s', display: 'flex', flexDirection: 'column' }}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                  >
                    {isAdded && (
                      <div style={{ position: 'absolute', bottom: '8px', left: '8px', right: '8px', background: '#16a34a', color: 'white', borderRadius: '6px', padding: '5px 10px', fontSize: '0.72rem', fontWeight: 600, textAlign: 'center', zIndex: 10, boxShadow: '0 2px 8px rgba(22,163,74,0.4)' }}>
                        ✓ Added to cart
                      </div>
                    )}

                    {savings && savings > 0 && (
                      <div style={{ position: 'absolute', top: '8px', left: '8px', background: '#dc2626', color: 'white', padding: '2px 7px', borderRadius: '20px', fontSize: '0.65rem', fontWeight: 700, zIndex: 1 }}>
                        Save {savings}%
                      </div>
                    )}

                    <div style={{ background: '#f8fafc', height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px' }}>
                      {product.image_url
                        ? <img src={mediaUrl(product.image_url)} alt={product.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display = 'none'; }} />
                        : <span style={{ fontSize: '2.5rem' }}>📦</span>
                      }
                    </div>

                    <div style={{ padding: '10px 10px 12px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <p style={{ fontSize: '0.8rem', fontWeight: 700, color: '#111827', lineHeight: 1.3, marginBottom: '2px', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{product.name}{product.unit ? ` (${product.unit})` : ''}</p>
                      <p style={{ fontSize: '0.68rem', color: '#9ca3af', marginBottom: '4px' }}>Min: {product.min_order || 1}{product.stock_label ? ` · ${product.stock_label}` : ''}</p>

                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '8px' }}>
                        <span style={{ fontSize: '0.82rem', fontWeight: 800, color: '#16a34a' }}>₹{price}{product.unit ? `/${product.unit}` : ''}</span>
                        {retail && <span style={{ fontSize: '0.68rem', textDecoration: 'line-through', color: '#9ca3af' }}>₹{retail}</span>}
                      </div>

                      <div style={{ marginTop: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: '6px', overflow: 'hidden', flexShrink: 0 }}>
                          <button onClick={() => handleQty(product.id, qty - 1, product.min_order || 1)} disabled={qty <= (product.min_order || 1)} style={{ width: 26, height: 28, background: '#f9fafb', border: 'none', cursor: qty <= (product.min_order || 1) ? 'not-allowed' : 'pointer', fontSize: '0.9rem', fontWeight: 700, color: '#374151', opacity: qty <= (product.min_order || 1) ? 0.35 : 1 }}>−</button>
                          <span style={{ minWidth: '28px', textAlign: 'center', fontSize: '0.78rem', fontWeight: 600 }}>{qty}</span>
                          <button onClick={() => handleQty(product.id, qty + 1, product.min_order || 1)} style={{ width: 26, height: 28, background: '#f9fafb', border: 'none', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 700, color: '#374151' }}>+</button>
                        </div>
                        <button onClick={() => handleAdd(product)}
                          style={{ padding: '6px 14px', background: '#16a34a', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 600, fontSize: '0.75rem', cursor: 'pointer', whiteSpace: 'nowrap' }} className="b2b-prod-add-btn-fix"
                          onMouseEnter={e => e.currentTarget.style.background = '#15803d'}
                          onMouseLeave={e => e.currentTarget.style.background = '#16a34a'}>
                          + Add
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
